import { defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { MODALS_MAP } from './';
import { useModal } from '~/composables';
export default defineComponent({
    name: 'BoxModal',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * Composables.
         */
        const css = useCssModule();
        const modal = useModal();
        function handleClick() {
            const { id = '' } = props.box?.data || {};
            if (!id) {
                return;
            }
            modal.open(MODALS_MAP[id]);
        }
        return {
            css,
            handleClick,
        };
    },
});
